<script setup lang="ts">
import { computed } from 'vue';
import { useScanQrcodeStore } from '@/store/internalCheck';
import { isEmpty } from '@/utitls';
import SocialChannel from '@/components/elements/SocialChannel.vue';

const store = useScanQrcodeStore();
const stamp_code = computed(() => store.stamp_code);
const { company } = stamp_code.value;

const isDarksTheme = computed(() => window.matchMedia("(prefers-color-scheme: dark)"));
</script>

<template>
  <el-card v-if="!isEmpty(company)">
    <div class="image flex justify-center mb-3">
      <el-image class="max-w-[100px] max-h-[100px]" :src="isDarksTheme ? company?.light_logo_url : company?.dark_logo_url" />
    </div>
    <div class="flex gap-2 justify-center mb-3 items-center" v-if="company?.address">
      <div>
        <svg
             width="24"
             height="24"
             viewBox="0 0 24 24"
             fill="none"
             xmlns="http://www.w3.org/2000/svg">
          <path
                d="M12.398 17.804L12.8585 18.6917V18.6917L12.398 17.804ZM11.602 17.804L11.1415 18.6917L11.1415 18.6917L11.602 17.804ZM18 9C18 11.1458 16.9079 12.9159 15.545 14.2906C14.183 15.6644 12.6342 16.555 11.9376 16.9163L12.8585 18.6917C13.6448 18.2838 15.397 17.2805 16.9653 15.6987C18.5326 14.1178 20 11.8706 20 9H18ZM12 3C15.3137 3 18 5.68629 18 9H20C20 4.58172 16.4183 1 12 1V3ZM6 9C6 5.68629 8.68629 3 12 3V1C7.58172 1 4 4.58172 4 9H6ZM12.0624 16.9163C11.3658 16.555 9.81702 15.6644 8.45503 14.2906C7.09211 12.9159 6 11.1458 6 9H4C4 11.8706 5.46741 14.1178 7.03474 15.6987C8.60299 17.2805 10.3552 18.2838 11.1415 18.6917L12.0624 16.9163ZM11.9376 16.9163C11.9514 16.9091 11.9733 16.9023 12 16.9023C12.0267 16.9023 12.0486 16.9091 12.0624 16.9163L11.1415 18.6917C11.6831 18.9726 12.3169 18.9726 12.8585 18.6917L11.9376 16.9163ZM14 9C14 10.1046 13.1046 11 12 11V13C14.2091 13 16 11.2091 16 9H14ZM12 7C13.1046 7 14 7.89543 14 9H16C16 6.79086 14.2091 5 12 5V7ZM10 9C10 7.89543 10.8954 7 12 7V5C9.79086 5 8 6.79086 8 9H10ZM12 11C10.8954 11 10 10.1046 10 9H8C8 11.2091 9.79086 13 12 13V11Z"
                fill="#6E8B91" />
          <path
                d="M19.7942 17.5C20.5841 17.9561 21 18.4734 21 19C21 19.5266 20.5841 20.0439 19.7942 20.5C19.0043 20.9561 17.8682 21.3348 16.5 21.5981C15.1318 21.8614 13.5798 22 12 22C10.4202 22 8.86817 21.8614 7.5 21.5981C6.13183 21.3348 4.99569 20.9561 4.20577 20.5C3.41586 20.0439 3 19.5266 3 19C3 18.4734 3.41586 17.9561 4.20577 17.5"
                stroke="#6E8B91"
                stroke-width="2"
                stroke-linecap="round" />
        </svg>
      </div>
      <div class="whitespace-pre-line" v-html="company?.address"></div>
    </div>
    <SocialChannel />
  </el-card>
</template>
